import { getParams, isProd } from "../utlis/helpers";

const { locale, accessToken } = getParams();

export const config = {
  headers: {
    "Accept-Language": locale,
    Accept: "application/json",
    Authorization: "Bearer " + accessToken,
    "Access-Control-Allow-Origin": "*",
  },
};
export const APP_URL = isProd
  ? "https://api.seniorlife.io/"
  : "https://api.dev.seniorlife.io/";
